module.exports = __webpack_public_path__ + "static/media/RequestReceived.688351bc.svg";